import { useEffect, useState } from 'react';

import { Pagination as BootstrapPagination } from 'react-bootstrap';

import { getPagination } from './utils/getPagination';

interface Props {
  currentPage: any;
  lastPage: number;
  page?: number;
  total: number;
  showMax?: number;
  onPage: (idx: number) => void;
}

function Pagination(props: Props) {
  const [page, setPage] = useState(props.currentPage);
  const [lastPage, setLastPage] = useState(props.lastPage);

  useEffect(() => {
    setPage(props.page);
  }, [props.page]);

  useEffect(() => {
    setLastPage(props.lastPage);
  }, [props.lastPage]);

  const items = () => {
    const pagination = getPagination({
      showMax: props.showMax ? props.showMax : 5,
      threeDots: true,
      currentPage: props.currentPage,
      totalPages: props.lastPage
    });

    return pagination.map((item, idx) => {
      if (item.isThreeDots) {
        return <BootstrapPagination.Ellipsis key={`eclipse-${idx}`} />;
      }

      return (
        <BootstrapPagination.Item
          key={item.page}
          active={item.isCurrent}
          onClick={() => props.onPage(item.page)}>
          {item.text}
        </BootstrapPagination.Item>
      );
    });
  };

  if (props.total === 0) {
    return <></>;
  }

  const currentPage = parseInt(props.currentPage);

  return (
    <div>
      <BootstrapPagination size="sm">
        <BootstrapPagination.Prev
          onClick={() => props.onPage(currentPage === 1 ? 1 : currentPage - 1)}
        />
        {items()}
        <BootstrapPagination.Next
          onClick={() =>
            props.onPage(currentPage === props.lastPage ? props.lastPage : currentPage + 1)
          }
        />
      </BootstrapPagination>
    </div>
  );
}

export { Pagination };
